var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tiptap-viewer"},[_c('div',{class:{'content-preview': _vm.isLongContent && !_vm.expanded}},[_c('editor-content',{ref:"editorContent",attrs:{"editor":_vm.viewer}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }